import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { FACTORY_PAGES } from "./lib/roles.ts";
import { GuidePage } from "./pages/GuidePage.tsx";
import { AccuracyPage } from "./pages/AccuracyPage.tsx";
import { Layout } from "./components/Layout.tsx";
import { DashboardPage } from "./pages/DashboardPage.tsx";
import { HomePage } from "./pages/HomePage.tsx";
import { OrderPage } from "./pages/OrderPage.tsx";
import { ArrivingPage } from "./pages/ArrivingPage.tsx";
import { SearchPage } from "./pages/SearchPage.tsx";
import { TrendsPage } from "./pages/TrendsPage.tsx";
import { ForecastPage } from "./pages/ForecastView.tsx";
import { DemandPage } from "./pages/DemandPage.tsx";
import { AdminPage } from "./pages/AdminPage.tsx";
import { PasswordPage } from "./pages/PasswordPage.tsx";
import { useMe } from "./hooks/useMe.tsx";

export function App() {
  const me = useMe();
  // A password account still on its one-time password sees only this until it picks its own.
  const loc = useLocation();
  if (me.data?.mustChangePassword) return <PasswordPage forced />;
  // Factory logins: any other page goes back to Home (the API refuses its data anyway).
  if (me.data?.role === "factory" && !FACTORY_PAGES.has(loc.pathname)) return <Navigate to="/" replace />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/order" element={<OrderPage />} />
        <Route path="/arriving" element={<ArrivingPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/overview" element={<DashboardPage />} />
        {/* Monitor and its tier alerts are retired (23 Oct): Trends shows use, To order and Arriving say what to do. */}
        <Route path="/monitor" element={<Navigate to="/trends" replace />} />
        <Route path="/forecast" element={<ForecastPage />} />
        <Route path="/trends" element={<TrendsPage />} />
        <Route path="/demand" element={<DemandPage />} />
        <Route path="/accuracy" element={<AccuracyPage />} />
        {/* Back-compat: old /history links redirect to /demand */}
        <Route path="/history" element={<Navigate to="/demand" replace />} />
        <Route path="/alerts" element={<Navigate to="/trends" replace />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/password" element={<PasswordPage />} />
      </Routes>
    </Layout>
  );
}
